import { render, staticRenderFns } from "./BroadcastCard.vue?vue&type=template&id=14866760&scoped=true&"
import script from "./BroadcastCard.vue?vue&type=script&lang=js&"
export * from "./BroadcastCard.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastCard.vue?vue&type=style&index=0&id=14866760&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14866760",
  null
  
)

export default component.exports